export const tabOptions = [
  {
    name: 'PRS',
    key: 'PRS'
  },
  {
    name: 'DRS',
    key: 'DRS'
  }
];

export const entityTypes = {
  PRS: 'PRS',
  DRS: 'DRS'
};

export const costTypes = {
  MAREKT_COST: 'MARKET_COST',
  HANDLING_COST: 'HANDLING_COST'
};

export const subTabOptions = [
  {
    name: 'Market Cost',
    key: 'MARKET_COST'
  },
  {
    name: 'Handling Cost',
    key: 'HANDLING_COST'
  }
];

export const tableData = {
  PRS: {
    headers: [
      'PRS No.',
      'Arriving Captain',
      'Cluster Name',
      'OU Code',
      'Vehicle Type',
      '# of CNs',
      'WT (kgs)',
      'PKGS',
      'Cost',
      'Cost Status',
      'Actions'
    ],
    dataKeys: [
      'prsId',
      'pickupUserName',
      'clusterName',
      'locationCode',
      'vehicleType',
      'numberOfConsignments',
      'totalWeight',
      'numberOfBoxes',
      'totalCost',
      'expenseStatus'
    ]
  },
  DRS: {
    headers: [
      'DRS Id',
      'BP/Vendor/CL',
      'Cluster Name',
      'OU Code',
      'Delivery PA/Captain',
      'Scheduled Departure',
      'Vehicle Type',
      'Wt- Pkgs',
      'Cost',
      'Cost Status',
      'Actions'
    ],
    dataKeys: [
      'drsId',
      'transportationPartnerName',
      'clusterName',
      'locationCode',
      'userName',
      'scheduledDispatchTime',
      'vehicleType',
      'totalBoxes,totalWeight',
      'totalCost',
      'expenseStatus'
    ]
  }
};

export const subTableDataPrs = {
  headers: [
    'CNs',
    'Dropoff Pending from (Days)',
    'Client',
    'From',
    'To',
    'WT(Kgs)',
    'PKGS'
  ],
  dataKeys: [
    'cnote',
    'firstInTransitToOuTime',
    'clientName',
    'fromPinCode',
    'toPinCode',
    'weight',
    'totalBoxes'
  ]
};

export const subTableDataDrs = {
  headers: [
    'CNo.',
    'Client (code)',
    'Customer Promise Date',
    'Rescheduled Promise Date',
    'Wt - Pkgs',
    'Pincode'
  ],
  dataKeys: [
    'cnote',
    'clientCode',
    'internalPromisedDeliveryDateTime',
    'rescheduledDeliveryDateTime',
    'weight',
    'toPinCode'
  ]
};

export const sortTableData = rows => {
  (rows || []).sort((a, b) => {
    if (a.expenseStatus === expenseStatus.waitingForSecondApproval) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.waitingForSecondApproval) {
      return 1;
    }
    if (a.expenseStatus === expenseStatus.waitingForApproval) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.waitingForApproval) {
      return 1;
    }
    if (a.expenseStatus === expenseStatus.approved) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.approved) {
      return 1;
    }
  });
};
export const expenseStatus = {
  waitingForSecondApproval: 'WAITING_FOR_SECOND_APPROVAL',
  waitingForApproval: 'WAITING_FOR_APPROVAL',
  approved: 'APPROVED',
  rejected: 'REJECTED'
};
